import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Beta: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m247.5 255h30v405h-30z' />
    <path d='m382.5 390v-30c57.9 0 105-47.1 105-105s-47.1-105-105-105c-27.84 0-54.16 11.28-74.11 31.75-19.92 20.44-30.89 47.26-30.89 75.51h-30c0-36.13 13.99-70.38 39.41-96.45 25.65-26.32 59.6-40.81 95.59-40.81 74.44 0 135 60.56 135 135s-60.56 135-135 135z' />
    <path d='m405 660v-30c66.17 0 120-53.83 120-120s-53.83-120-120-120v-30c82.71 0 150 67.29 150 150s-67.29 150-150 150z' />
    <path d='m330 360h85v30h-85z' />
    <path d='m330 630h75v30h-75z' />
  </IconBase>
));

Beta.displayName = 'Beta';

export default Beta;
